import "./App.css";
import { Routes, Route } from "react-router-dom"
import GoogleSignIn from "./GoogleSignIn";
import Main from "./Main";
import CountdownTimer from "./ComingSoon";
function App() {
  
  
  return (
    <>
     <Routes>
     
     {/* <Route path="/" element={<CountdownTimer targetDate="2025-02-15T00:00:00"></CountdownTimer>} />             
     <Route path="/home" element={<CountdownTimer targetDate="2025-02-15T00:00:00"></CountdownTimer>} />
     <Route path="*" element={<CountdownTimer targetDate="2025-02-15T00:00:00"></CountdownTimer>} /> */}
     
        <Route path="/" element={<Main></Main>} />
        <Route path="/auth" element={<GoogleSignIn></GoogleSignIn>} />         
        <Route path="*" element={<Main></Main>} />
      </Routes>
    </>
  );
}
export default App;
